import benefitsImg from './img/benefits-of-having-a-website.webp';
import whyImg from './img/why-img.webp';
import webvsSocial from './img/content-social.jpg'

export const Articles = [
    {
        title : 'Why Every Business Needs A Website',
        author : 'Kasey Kaplan',
        link : 'https://www.forbes.com/sites/theyec/2020/02/03/why-every-business-needs-a-website/?sh=cfb603b6e75c',
        img: whyImg
    },
    {
        title : '10 Benefits of Having a Website For Your Business',
        author : 'Krystianna Pietrzak',
        link : 'https://www.goatsontheroad.com/benefits-of-having-a-website/',
        img: benefitsImg
    },
    {
        title : 'Website vs Social Media – Which Is Better For Your Company?',
        author : 'Frank DePino',
        link : 'https://mediaboom.com/news/website-vs-social-media/',
        img: webvsSocial
    }
]